import React, { useMemo, useRef, useState } from "react";
import { Search, X } from "lucide-react";
import MOShell from "@/components/masterOrder/MOShell";
import {
  ANOKINA_CUP_ML,
  MEASURE_DISCLAIMER,
  formatMeasureNumber,
  verifiedDirectoryRows,
} from "./measureDirectory.mjs";

const metricCell = (value) => value == null ? "—" : `${formatMeasureNumber(value)} г`;

export default function MOMeasureDirectory() {
  const [query, setQuery] = useState("");
  const searchRef = useRef(null);
  const rows = useMemo(() => {
    const normalized = query.trim().toLocaleLowerCase("ru");
    return verifiedDirectoryRows().filter((row) =>
      !normalized || row.ingredient.toLocaleLowerCase("ru").includes(normalized)
    );
  }, [query]);

  return (
    <MOShell active="measure-directory" title="Справочник мер" back="/master-order">
      <div className="max-w-5xl mx-auto px-4 md:px-6 pb-16 pt-4" data-testid="mo-measure-directory">
        <div className="rounded-xl p-4 mb-4"
             style={{ background: "#FBF3E4", color: "#5B4326", boxShadow: "inset 0 0 0 1px #EFE4D0" }}
             data-testid="mo-measure-disclaimer">
          <div className="text-[13px]">{MEASURE_DISCLAIMER}</div>
        </div>

        <div className="rounded-xl bg-white p-4" style={{ boxShadow: "inset 0 0 0 1px #EFE4D0" }}>
          <label className="flex items-center gap-2 h-10 px-3 rounded-md mb-4"
                 style={{ boxShadow: "inset 0 0 0 1px #EFE4D0", color: "#8B6F4B" }}>
            <Search size={15} />
            <input ref={searchRef} value={query} onChange={(event) => setQuery(event.target.value)}
                   placeholder="Найти ингредиент"
                   className="flex-1 min-w-0 bg-transparent outline-none text-base md:text-[13px] placeholder:text-[#B9A692]"
                   data-testid="mo-measure-search" />
            {query && (
              <button type="button"
                      onClick={() => {
                        setQuery("");
                        requestAnimationFrame(() => searchRef.current?.focus());
                      }}
                      aria-label="Очистить поиск"
                      className="w-7 h-7 shrink-0 rounded-full grid place-items-center"
                      style={{ background: "#F7F1E7", color: "#8B6F4B" }}
                      data-testid="mo-measure-search-clear">
                <X size={13} />
              </button>
            )}
          </label>

          <div className="overflow-x-auto">
            <table className="w-full min-w-[640px] text-left" data-testid="mo-measure-table">
              <thead>
                <tr className="text-[10.5px] tracking-[0.12em] uppercase" style={{ color: "#8B6F4B" }}>
                  <th className="px-3 py-2 font-normal">Ингредиент</th>
                  <th className="px-3 py-2 font-normal">1 ч. л. ≈</th>
                  <th className="px-3 py-2 font-normal">1 ст. л. ≈</th>
                  <th className="px-3 py-2 font-normal">1 стакан {ANOKINA_CUP_ML} мл ≈</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.ingredient} className="border-t border-[#EFE4D0] text-[13px]" style={{ color: "#2A1D14" }}>
                    <td className="px-3 py-3">{row.ingredient}</td>
                    <td className="px-3 py-3 tabular-nums">{metricCell(row.tsp)}</td>
                    <td className="px-3 py-3 tabular-nums">{metricCell(row.tbsp)}</td>
                    <td className="px-3 py-3 tabular-nums">{metricCell(row.cup)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {rows.length === 0 && (
            <div className="py-8 text-center text-[13px]" style={{ color: "#8B6F4B" }}>
              В проверенном справочнике пока нет такого ингредиента.
            </div>
          )}
        </div>
      </div>
    </MOShell>
  );
}
